import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { ToastProvider } from '@/contexts/ToastContext'
import { TenantProvider } from '@/contexts/TenantContext'
import { UserProvider } from '@/contexts/UserContext'
import { bootstrapTenantFromBuild, isNativeWhiteLabelBuild } from '@/config/tenant'
import { isNativeAppRuntime } from '@/config/runtime'
import { bootstrapAppTheme } from '@/utils/theme'
import App from './App'
import './index.css'
import './styles/native-app.css'

bootstrapTenantFromBuild()
if (typeof document !== 'undefined' && (isNativeWhiteLabelBuild() || isNativeAppRuntime())) {
  document.documentElement.classList.add('native-app')
}
bootstrapAppTheme()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <UserProvider>
        <TenantProvider>
          <ToastProvider>
            <App />
          </ToastProvider>
        </TenantProvider>
      </UserProvider>
    </BrowserRouter>
  </StrictMode>,
)
